import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      nav("/admin/login", { replace: true });
      return;
    }

    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        nav("/admin", { replace: true, state: { user: r.data } });
      })
      .catch(() => nav("/admin/login", { replace: true }));
  }, [location, nav, setUser]);

  return (
    <div data-testid="auth-callback" className="container-x py-32 text-center text-[#4A4D50]">
      Signing you in…
    </div>
  );
}
